import React from "react";
import MobileTableStack from "../../base/MobileTableStack";
import SearchResults from "../../../types/searchResults";
import TableData from "../../../types/tableData";

interface Props {
  id: number;
  tileTable: SearchResults;
}

const TileDataStack: React.FC<Props> = (props) => {
  const { tileTable } = props;

  const rows =
    tileTable &&
    tileTable?.results?.map((data: TableData, index) => {
      const rowObject: Record<string, string | undefined> = {
        id: `${index}`,
      };
      data.values?.forEach((value, index) => {
        const key = tileTable.headers![index] || `key${index + 1}`;
        rowObject[key] = value;
      });

      return rowObject;
    });

  const headers =
    !!tileTable && !!tileTable.headers
      ? tileTable.headers.map((header) => {
          return header;
        })
      : [];

  return rows?.length ? (
    <MobileTableStack rows={rows!} headers={headers} />
  ) : (
    <></>
  );
};

export default TileDataStack;
